import React from "react";

import { useApp } from "../../contexts/AppContext";

import CreateOrJoinParty from "../CreateOrJoinParty/CreateOrJoinParty";
import LetsParty from "../LetsParty/LetsParty";
import MyParties from "../MyParties/MyParties";

function Event() {
  const {
    state: { myPartyUsers, selectedPartyId, party, partyUser },
  } = useApp();

  if (myPartyUsers.length === 0) {
    return <CreateOrJoinParty />;
  }

  if (!selectedPartyId) {
    return <MyParties />;
  }

  if (partyUser?.active && party) {
    return <LetsParty />;
  }

  return null;
}

export default Event;
